import { render, staticRenderFns } from "./DemoDatepickerShowSiblingMonths.vue?vue&type=template&id=26cda202&"
import script from "./DemoDatepickerShowSiblingMonths.vue?vue&type=script&lang=js&"
export * from "./DemoDatepickerShowSiblingMonths.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VDatePicker})
